export default __webpack_public_path__ + "static/media/auth-background.7f8b632f.png";